import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';
import {Columns} from '@shared/interfaces/table/column-config';

export const connectiontypePartial: Columns<any> = {
  title: 'meteringPoint.connectionType.title',
  key: 'connectionType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'meteringPoint.connectionType.notSpecified',
    directconnected: 'meteringPoint.connectionType.directConnected',
    installationconnected: 'meteringPoint.connectionType.installationConnected',
  }
}
